/**
 * React Static Boilerplate
 * https://github.com/kriasoft/react-static-boilerplate
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  close: {
    padding: theme.spacing.unit / 2
  }
});

const enhance = compose(
  connect(({ app: { updateAvailable } }) => ({
    updateAvailable
  })),
  withStyles(styles)
);

class UpdateSnackbar extends React.Component {
  state = {
    show: true
  };

  handleRefresh = () => {
    // Grab Service Worker from Global Scope
    if (window.myServiceWorker && window.myServiceWorker.waiting) {
      // Tell Service Worker not to wait for all tabs to close.
      window.myServiceWorker.waiting.postMessage({ action: 'skipWaiting' });
    }
    // Reload page.
    window.location.reload(true);
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  render() {
    const { classes, updateAvailable } = this.props;
    const { show } = this.state;

    // console.log('updateAvailable', updateAvailable);

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={show && updateAvailable}
        onClose={this.handleClose}
        ContentProps={{
          'aria-describedby': 'message-id'
        }}
        message={
          <span id="message-id">
            App update available. Close all tabs, or click refresh.
          </span>
        }
        action={[
          <Button
            key="undo"
            color="secondary"
            size="small"
            onClick={this.handleRefresh}
          >
            REFRESH
          </Button>,
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={this.handleClose}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
    );
  }
}

export default enhance(UpdateSnackbar);
